import { useMutation } from '@tanstack/react-query'

import { useToast } from '@/src/general/components/ToastContext'
import { extractKeyFromError } from '@/src/general/errors/extractKeyFromError'
import { useTranslate } from '@/src/lang/useTranslate'

import { contactApi } from '../api/contactApi'

export const useContactFormMutation = () => {
  const { t } = useTranslate()
  const toast = useToast()

  return useMutation({
    mutationFn: contactApi.sendContactMessage,
    onSuccess: () => {
      toast.addToast({
        message: t('contact.success.toast'),
        colors: 'success',
      })
    },
    onError: (error) => {
      const key = extractKeyFromError(error)
      toast.addToast({
        message: key ? t(key) : t('app.error'),
        colors: 'danger',
      })
    },
  })
}
